/**
 * Data structure for formatted address parts
 */
export interface FormattedAddress {
	/** First part of the address (before first comma) */
	firstPart: string;
	/** Second part of the address (after first comma) */
	secondPart: string;
	/** Full original address */
	fullAddress: string;
}

/**
 * Formats an address by splitting it into two parts at the first comma
 *
 * Used for displaying addresses in a two-row format:
 * - First row: everything before the first comma
 * - Second row: everything after the first comma
 */
export const formatAddress = (address: string): FormattedAddress => {
	const parts = address.split(',');
	const firstPart = parts[0]?.trim() || '';
	const secondPart = parts.slice(1).join(',').trim() || '';

	return {
		firstPart,
		secondPart,
		fullAddress: address,
	};
};
